import { ReactElement, useEffect } from 'react';
import {
  Checkbox,
  FormControlLabel,
  Grid,
  SelectChangeEvent,
  useEventCallback,
} from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { useFormikContext } from 'formik';
import { FilterPracticeVM } from 'practice/view-models/practice-research';
import TypeRegisterList from './list/type-register-list';
// import YearsList from './list/years-list';
import PmiTextField from 'shell/components/shared/text-field';
import { DatePicker } from '@mui/lab';
// import ServiceList from './list/service-list';
// import OperatorList from './list/operator-list';
import StateList from '../../state-list';
import AcquisitionSystemList from '../../acquisition-system-list';
import { defaultInitialValuesPractice } from '..';
import { useFilterTable } from 'shell/hooks/use-filter-table';
import { PracticeSearchType } from 'practice/pages/storage-practice';
import ListTypeOperation from 'practice/components/metric/shared/list-type-operation';
import { useListener } from 'shell/hooks/use-bus';
import { EventFormPractice } from 'practice/constants/research-state-enum';
import OperatorList from 'front-office/components/shared/operator-list';
import PracticePlacementServiceList from '../../practice-placement-service-list';
import { TypeDomainPractice } from 'practice/constants/type-practice-domain';
import { TypeRegister } from 'practice/constants/type-register';
import OriginForm from './origin';

const FormFilter = ({
  // authPerson,
  isResearch,
}: {
  authPerson?: string;
  isResearch?: boolean;
}): ReactElement => {
  const formContext = useFormikContext<FilterPracticeVM>();

  const filterTable = useFilterTable<PracticeSearchType>();

  useListener<FilterPracticeVM>(EventFormPractice.UpdateForm, (form) => {
    formContext.setValues({ ...formContext.values, ...form });
  });

  useEffect(() => {
    filterTable.setValues(formContext.values);
  }, [formContext.values]);

  useEffect(() => {
    formContext.setValues(filterTable.values || defaultInitialValuesPractice);
  }, []);

  const onChangeTypeRegister = useEventCallback((event: SelectChangeEvent<string>) => {
    formContext.setFieldValue('typeRegister', event.target.value);
  });

  // const onChangeYears = useEventCallback((event: SelectChangeEvent<string>) => {
  //   formContext.setFieldValue('years', event.target.value);
  // });

  // const onChangeService = useEventCallback((value: string | undefined) => {
  //   formContext.setFieldValue('service', value);
  // });

  const onChangeOperator = useEventCallback((value: string | undefined) => {
    formContext.setFieldValue('operator', value);
  });

  const onChangeState = useEventCallback((value: string | undefined) => {
    formContext.setFieldValue('state', value);
  });

  const onChangeAcquisitionSystem = useEventCallback((value: string | undefined) => {
    formContext.setFieldValue('acquisitionSystem', value);
  });

  const onChangePracticePlacementService = useEventCallback((value: string | undefined) => {
    formContext.setFieldValue('practicePlacementService', value);
  });

  const onChangeLastTypeOperation = useEventCallback((event: SelectChangeEvent<string>) => {
    formContext.setFieldValue('lastTypeOperation', event.target.value);
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={3}>
        <TypeRegisterList
          onChange={onChangeTypeRegister}
          value={formContext.values.typeRegister || ''}
          error={formContext.touched.typeRegister && Boolean(formContext.errors.typeRegister)}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        {/* <YearsList
          onChange={onChangeYears}
          value={formContext.values.years || ''}
          typeRegister={formContext.values.typeRegister || ''}
          disabled={!Boolean(formContext.values.typeRegister)}
        /> */}
        <PmiTextField
          label="Anno"
          aria-label="Anno"
          name="years"
          id="years"
          fullWidth
          value={formContext.values.years || ''}
          inputProps={{ min: 0 }}
          onChange={(event) => {
            formContext.setFieldValue('years', event.target.value);
          }}
          error={formContext.touched.years && Boolean(formContext.errors.years)}
          helperText={formContext.errors.years}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          label="Da numero"
          aria-label="Da numero"
          name="fromNumber"
          id="fromNumber"
          fullWidth
          value={formContext.values.fromNumber || ''}
          inputProps={{ min: 0 }}
          onChange={(event) => {
            if (!Number.isInteger(Number.parseInt(event.target.value, 10))) {
              formContext.setFieldValue('fromNumber', undefined);

              return;
            }

            if (Number.parseInt(event.target.value || '0', 10) >= 0) {
              // solo positivi
              formContext.setFieldValue('fromNumber', Number.parseInt(event.target.value, 10) || 0);

              return;
            }

            formContext.setFieldValue('fromNumber', 0);
          }}
          error={formContext.touched.fromNumber && Boolean(formContext.errors.fromNumber)}
          helperText={formContext.errors.fromNumber}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          label="A numero"
          aria-label="A numero"
          name="atNumber"
          id="atNumber"
          fullWidth
          value={formContext.values.atNumber || ''}
          inputProps={{ min: 0 }}
          onChange={(event) => {
            if (!Number.isInteger(Number.parseInt(event.target.value, 10))) {
              formContext.setFieldValue('atNumber', undefined);

              return;
            }

            if (Number.parseInt(event.target.value || '0', 10) >= 0) {
              // solo positivi
              formContext.setFieldValue('atNumber', Number.parseInt(event.target.value, 10) || 0);

              return;
            }

            formContext.setFieldValue('fromNumber', 0);
          }}
          error={formContext.touched.atNumber && Boolean(formContext.errors.atNumber)}
          helperText={formContext.errors.atNumber}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <DatePicker
          label="Data apertura dal"
          aria-label="Data apertura dal"
          value={formContext.values.dateFrom || null}
          onChange={(date) => {
            formContext.setFieldValue('dateFrom', date || null);
          }}
          renderInput={(params) => (
            <PmiTextField
              id="dateForm"
              {...params}
              fullWidth
              error={formContext.touched.dateFrom && Boolean(formContext.errors.dateFrom)}
              helperText={formContext.errors.dateFrom}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <DatePicker
          label="Data apertura al"
          aria-label="Data apertura al"
          value={formContext.values.dateTo || null}
          onChange={(date) => {
            formContext.setFieldValue('dateTo', date || null);
          }}
          renderInput={(params) => <PmiTextField id="dateTo" {...params} fullWidth helperText="" />}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <DatePicker
          label="Data chiusura"
          aria-label="Data chiusura"
          value={formContext.values.dateClosure || null}
          onChange={(date) => {
            formContext.setFieldValue('dateClosure', date || null);
          }}
          renderInput={(params) => (
            <PmiTextField id="dateClosure" {...params} fullWidth helperText="" />
          )}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <DatePicker
          label="Data scadenza"
          aria-label="Data scadenza"
          value={formContext.values.dateExpiration || null}
          onChange={(date) => {
            formContext.setFieldValue('dateExpiration', date || null);
          }}
          renderInput={(params) => (
            <PmiTextField id="dateExpiration" {...params} fullWidth helperText="" />
          )}
        />
      </Grid>
      {isResearch ? (
        <>
          <Grid item xs={12} md={3}>
            <DatePicker
              label="Data decorrenza da"
              aria-label="Data decorrenza da"
              value={formContext.values.dataDecorrenzaDa || null}
              onChange={(date) => {
                formContext.setFieldValue('dataDecorrenzaDa', date || null);
              }}
              renderInput={(params) => (
                <PmiTextField
                  id="dataDecorrenzaDa"
                  {...params}
                  fullWidth
                  error={
                    formContext.touched.dataDecorrenzaDa &&
                    Boolean(formContext.errors.dataDecorrenzaDa)
                  }
                  helperText={formContext.errors.dataDecorrenzaDa}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <DatePicker
              label="Data decorrenza a"
              aria-label="Data decorrenza a"
              value={formContext.values.dataDecorrenzaA || null}
              onChange={(date) => {
                formContext.setFieldValue('dataDecorrenzaA', date || null);
              }}
              renderInput={(params) => (
                <PmiTextField
                  id="dataDecorrenzaA"
                  {...params}
                  fullWidth
                  error={
                    formContext.touched.dataDecorrenzaA &&
                    Boolean(formContext.errors.dataDecorrenzaA)
                  }
                  helperText={formContext.errors.dataDecorrenzaA}
                />
              )}
            />
          </Grid>
        </>
      ) : undefined}
      {!isResearch ? (
        <Grid item xs={12} md={4}>
          <OperatorList
            onChange={onChangeOperator}
            value={formContext.values.operator || ''}
            operatorType="0"
          />
        </Grid>
      ) : undefined}
      {/* <Grid item xs={12} md={4}>
        <OperatorList
          onChange={onChangeOperator}
          value={formContext.values.operator || ''}
          codService={formContext.values.service}
          disabled={!Boolean(formContext.values.service)}
        />
      </Grid> */}
      <Grid item xs={12} md={isResearch ? 3 : 4}>
        <AcquisitionSystemList
          onChange={onChangeAcquisitionSystem}
          value={formContext.values.acquisitionSystem || ''}
          typePractice={TypeDomainPractice.Tipo1}
        />
      </Grid>
      <Grid item xs={12} md={isResearch ? 3 : 4}>
        <PracticePlacementServiceList
          onChange={onChangePracticePlacementService}
          value={formContext.values.practicePlacementService || ''}
        />
      </Grid>
      <Grid item container spacing={2}>
        <Grid item xs={12} md={3}>
          <StateList onChange={onChangeState} value={formContext.values.state || ''} />
        </Grid>
        <Grid item xs={12} md={3}>
          <ListTypeOperation
            onChange={onChangeLastTypeOperation}
            value={formContext.values.lastTypeOperation || ''}
            typeRegister={formContext.values.typeRegister}
            disabled={!formContext.values.typeRegister}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <PmiTextField
            label="Progressivo accertamento"
            aria-label="Progressivo accertamento"
            name="progressivo"
            id="progressivo"
            fullWidth
            type="number"
            value={formContext.values.progressive || ''}
            inputProps={{ min: 0 }}
            onChange={(event) => {
              if (!Number.isInteger(Number.parseInt(event.target.value, 10))) {
                formContext.setFieldValue('progressive', undefined);

                return;
              }

              if (Number.parseInt(event.target.value || '0', 10) >= 0) {
                // solo positivi
                formContext.setFieldValue(
                  'progressive',
                  Number.parseInt(event.target.value, 10) || 0
                );

                return;
              }
            }}
            error={formContext.touched.progressive && Boolean(formContext.errors.progressive)}
            helperText={formContext.errors.progressive}
            disabled={
              formContext.values.typeRegister !== TypeRegister.Unavailable &&
              formContext.values.typeRegister !== TypeRegister.UntraceableCensus
            }
          />
        </Grid>

        <Grid item xs={12} md={3}>
          <PmiTextField
            label="Nr pratica ANPR"
            aria-label="Numero pratica ANPR"
            name="numberAnpr"
            id="numberAnpr"
            fullWidth
            type="number"
            value={formContext.values.numberAnpr || ''}
            inputProps={{ min: 0 }}
            onChange={(event) => {
              if (!Number.isInteger(Number.parseInt(event.target.value, 10))) {
                formContext.setFieldValue('numberAnpr', undefined);

                return;
              }

              if (Number.parseInt(event.target.value || '0', 10) >= 0) {
                // solo positivi
                formContext.setFieldValue(
                  'numberAnpr',
                  Number.parseInt(event.target.value, 10) || 0
                );

                return;
              }
            }}
            // error={formContext.touched.atNumber && Boolean(formContext.errors.atNumber)}
            // helperText={formContext.errors.atNumber}
          />
        </Grid>
      </Grid>
      <Grid item container spacing={1} xs={12}>
        <Grid item xs={12} md={3} display="flex" alignItems="center">
          <FormControlLabel
            control={
              <Checkbox
                id="accertamentoPositivo"
                checked={formContext.values?.accertamentoPositivo || false}
                onChange={(event) => {
                  formContext.setFieldValue('accertamentoPositivo', event.target.checked);
                }}
                disabled={formContext.values.lastTypeOperation !== '09'}
                inputProps={{ 'aria-label': 'Accertamento positivo' }}
              />
            }
            label="Accertamento positivo"
          />
        </Grid>
        <Grid item xs={12} md={3} display="flex" alignItems="center">
          <FormControlLabel
            control={
              <Checkbox
                id="accertamentoNegativo"
                checked={formContext.values?.accertamentoNegativo || false}
                onChange={(event) => {
                  formContext.setFieldValue('accertamentoNegativo', event.target.checked);
                }}
                disabled={formContext.values.lastTypeOperation !== '09'}
                inputProps={{ 'aria-label': 'Accertamento negativo' }}
              />
            }
            label="Accertamento negativo"
          />
        </Grid>
        <Grid item xs={12} md={3} display="flex" alignItems="center">
          <FormControlLabel
            control={
              <Checkbox
                id="accertamentoDubbio"
                checked={formContext.values?.accertamentoDubbio || false}
                onChange={(event) => {
                  formContext.setFieldValue('accertamentoDubbio', event.target.checked);
                }}
                disabled={formContext.values.lastTypeOperation !== '09'}
                inputProps={{ 'aria-label': 'Accertamento dubbio' }}
              />
            }
            label="Accertamento dubbio"
          />
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <OriginForm
          values={formContext.values.origin || undefined}
          onChange={(key, value) => {
            formContext.setValues({
              ...formContext.values,
              irreperibileAltroComune: false,
              irreperibileMilano: false,
              origin: formContext.values.origin
                ? {
                    ...(formContext.values.origin || {}),
                    [key]: value,
                  }
                : undefined,
            });
          }}
          onChangeFields={(values) => {
            formContext.setValues({
              ...formContext.values,
              irreperibileAltroComune: false,
              irreperibileMilano: false,
              origin: {
                ...(formContext.values.origin || {}),
                ...values,
              },
            });
          }}
        />
      </Grid>
      <Grid item container spacing={1} xs={12}>
        <Grid item xs={12} md={6}>
          <FormControlLabel
            control={
              <Checkbox
                id="only-assigned-practice"
                checked={formContext.values?.onlyPracticeAssigned || false}
                onChange={() => {
                  formContext.setFieldValue(
                    'onlyPracticeAssigned',
                    !formContext.values.onlyPracticeAssigned
                  );
                }}
                inputProps={{ 'aria-label': 'Solo pratiche assegnate' }}
                // disabled={authPerson === '0'}
              />
            }
            label="Solo pratiche assegnate"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControlLabel
            control={
              <Checkbox
                id="priority-practice"
                checked={formContext.values?.prioritaSenzaAssensoOspitante || false}
                onChange={() => {
                  formContext.setFieldValue(
                    'prioritaSenzaAssensoOspitante',
                    !formContext.values.prioritaSenzaAssensoOspitante
                  );
                }}
                inputProps={{ 'aria-label': 'Priorità (senza assenso ospitante)' }}
              />
            }
            label="Priorità (senza assenso ospitante)"
          />
        </Grid>
      </Grid>
      <Grid item container spacing={1} xs={12}>
        <Grid item xs={12} md={3} display="flex" alignItems="center">
          <FormControlLabel
            control={
              <Checkbox
                id="irreperibile-Milano"
                checked={formContext.values?.irreperibileMilano || false}
                onChange={(event) => {
                  formContext.setValues({
                    ...formContext.values,
                    origin: null,
                    irreperibileAltroComune: false,
                    irreperibileMilano: event.target.checked,
                  });
                }}
                inputProps={{ 'aria-label': 'Irreperibile Milano' }}
              />
            }
            label="Irreperibile Milano"
          />
        </Grid>
        <Grid item xs={12} md={3} display="flex" alignItems="center">
          <FormControlLabel
            control={
              <Checkbox
                id="irreperibile-other"
                checked={formContext.values?.irreperibileAltroComune || false}
                onChange={(event) => {
                  formContext.setValues({
                    ...formContext.values,
                    origin: null,
                    irreperibileMilano: false,
                    irreperibileAltroComune: event.target.checked,
                  });
                }}
                inputProps={{ 'aria-label': 'Irreperibile Altro Comune' }}
              />
            }
            label="Irreperibile Altro Comune"
          />
        </Grid>
        <Grid item xs={12} md={3} display="flex" alignItems="center">
          <FormControlLabel
            control={
              <Checkbox
                id="citizenship-italian"
                checked={formContext.values?.italianCitizenship || false}
                onChange={(event) => {
                  formContext.setValues({
                    ...formContext.values,
                    foreignCitizenship: false,
                    italianCitizenship: event.target.checked,
                  });
                }}
                inputProps={{ 'aria-label': 'Cittadinanza Italiana' }}
              />
            }
            label="Cittadinanza Italiana"
          />
        </Grid>
        <Grid item xs={12} md={3} display="flex" alignItems="center">
          <FormControlLabel
            control={
              <Checkbox
                id="citizenship-foreign"
                checked={formContext.values?.foreignCitizenship || false}
                onChange={(event) => {
                  formContext.setValues({
                    ...formContext.values,
                    italianCitizenship: false,
                    foreignCitizenship: event.target.checked,
                  });
                }}
                inputProps={{ 'aria-label': 'Cittadinanza Estera' }}
              />
            }
            label="Cittadinanza Estera"
          />
        </Grid>
      </Grid>
      <Grid item container spacing={2} xs={12} justifyContent="space-between" display="flex">
        <Grid item container spacing={2} xs={12} justifyContent="flex-end" display="flex">
          <Grid item xs={12} md={2}>
            <PmiButton
              variant="outlined"
              color="cdmBrandThird"
              fullWidth
              onClick={() => formContext.resetForm()}
            >
              Ripulisci
            </PmiButton>
          </Grid>
          <Grid item xs={12} md={2}>
            <PmiButton variant="contained" color="cdmBrandThird" fullWidth type="submit">
              Cerca
            </PmiButton>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

FormFilter.displayName = 'Practice Research - Filter Practice - Form Filter component';

export default FormFilter;
